<app-mainmenu
              title="Leergewicht wiegen"
              [back]="true"
              backUrl="/home"></app-mainmenu>

<ion-content class="section-content">

</ion-content>
